import React, { Component } from 'react';
import { Api } from '../../../lib/api';
import { POLARITY_TYPE__A, POLARITY_TYPE__B, POLARITY_TYPE__C } from '@shared/constants/constants';

import {
    InputNumber,
    message,
    Input,
    Button,
    Modal,
    Radio
} from 'antd';
const regExp = /[a-zA-Z]/g;

class CreatePolarityModal extends Component {
    state = {
        name: this.props.name,
        mapping: this.props.mapping,
        numFibers: this.props.numFibers,
        polarityType: this.props.polarityType,
        tableIndex: this.props.tableIndex,
        numRows: this.props.numRows
    };

    close = () => {
       this.props.close();
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            (this.state.createNew !== prevState.createNew ||
                this.state.polarityType !== prevState.polarityType ||
                this.state.numFibers !== prevState.numFibers) &&
            (this.state.polarityType === POLARITY_TYPE__A ||
                this.state.polarityType === POLARITY_TYPE__B ||
                this.state.polarityType === POLARITY_TYPE__C)
        ) {
            if (this.state.createNew) {
                // Do nothing
            } else if (this.state.polarityType === POLARITY_TYPE__A) {
                this.setState((state) => ({
                    mapping: Array(state.numFibers)
                        .fill('')
                        .map((v, i) => i + 1),
                    tableIndex: state.tableIndex + 1
                }));
            } else if (this.state.polarityType === POLARITY_TYPE__B) {
                this.setState((state) => ({
                    mapping: Array(state.numFibers)
                        .fill('')
                        .map((v, i) => state.numFibers - i),
                    tableIndex: state.tableIndex + 1
                }));
            } else if (this.state.polarityType === POLARITY_TYPE__C) {
                this.setState((state) => ({
                    mapping: Array(state.numFibers)
                        .fill('')
                        .map((v, i) => (i % 2 ? i : i + 1 === state.numFibers ? i + 2 : i + 2)),
                    tableIndex: state.tableIndex + 1
                }));
            }
        }
    }

    render() {
        return(
            <Modal
                title="Create Polarity"
                width="820px"
                onCancel={this.close}
                open={this.props.isOpen}
                destoryOnClose={true}
                closable={true}
                footer={
                    <div className="footer">
                        <div className="buttons">
                            <Button
                                type="primary"
                                onClick={() => {
                                    if (this.state.mapping.includes(null)) {
                                        alert('Please fill all the required fields.');
                                        return;
                                    }
                                    let mapping = this.state.mapping
                                        .slice(0, this.state.numFibers)
                                        .map((v) => (v === '' ? '-' : v))
                                        .join(',');
                                    
                                    Api.createPolarity(this.state.name, this.state.numFibers, mapping)
                                        .then((polarity) => {
                                            message.success('Save successful', 3);
                                            this.props.updatePolarities(polarity);
                                            this.close();
                                        })
                                        .catch(() => {
                                            message.error('Failed to create polarity type');
                                        });
                                }}
                            >
                                Create
                            </Button>
                            <Button
                                onClick={() => {
                                    this.close();
                                }}
                            >
                                Cancel
                            </Button>
                        </div>
                    </div>
                }
            >
                <React.Fragment>
                    <div className="title">Polarity Type:</div>

                    <Input
                        defaultValue={this.state.name}
                        onChange={(e) => this.setState({ name: e.target.value })}
                        autoFocus
                    />
                    <div className="title">Preset:</div>
                    <Radio.Group
                        defaultValue={this.state.polarityType}
                        onChange={(value) => {
                            this.setState({ polarityType: value.target.value });
                        }}
                    >
                        <Radio.Button value={POLARITY_TYPE__A}>A</Radio.Button>
                        <Radio.Button value={POLARITY_TYPE__B}>B</Radio.Button>
                        <Radio.Button value={POLARITY_TYPE__C}>C</Radio.Button>
                    </Radio.Group>

                    <React.Fragment key={this.state.tableIndex}>
                        <div className="cable-mapping-table-2">
                            {
                                // For each row
                                [...Array(this.state.numRows)].map((v1, rowIndex) => (
                                    <React.Fragment key={'row-' + rowIndex}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                fontStyle: 'italic',
                                                fontWeight: '500'
                                            }}
                                        >
                                            <div>
                                                Output({12 * rowIndex + 1}-{12 * rowIndex + 12})
                                            </div>
                                            <div style={{ color: 'blue' }}>
                                                Input ({12 * rowIndex + 1}-{12 * rowIndex + 12})
                                            </div>
                                        </div>
                                        {
                                            // For each column
                                            [
                                                ...Array(
                                                    rowIndex + 1 < this.state.numRows
                                                        ? 12
                                                        : this.state.numFibers - (this.state.numRows - 1) * 12
                                                )
                                            ].map((v2, columnIndex) => (
                                                <div
                                                    key={'cell-' + (rowIndex * 12 + columnIndex)}
                                                    style={{ display: 'flex', flexDirection: 'column' }}
                                                >
                                                    <div>{12 * rowIndex + 1 + columnIndex}</div>
                                                    <InputNumber
                                                        defaultValue={
                                                            this.state.mapping[rowIndex * 12 + columnIndex]
                                                        }
                                                        onChange={(value) => {
                                                            if (
                                                                value !== undefined &&
                                                                value >= 0 &&
                                                                value < 10000
                                                            ) {
                                                                this.setState((state) => {
                                                                    let mapping = [...state.mapping];
                                                                    mapping[rowIndex * 12 + columnIndex] =
                                                                        value;
                                                                    return { mapping };
                                                                });
                                                            }
                                                        }}
                                                        formatter={(value) => {
                                                            if (regExp.test(value)) {
                                                                return value.replace(regExp, '');
                                                            } else {
                                                                return value;
                                                            }
                                                        }}
                                                        min={0}
                                                        style={{ color: 'blue' }}
                                                    />
                                                </div>
                                            ))
                                        }
                                    </React.Fragment>
                                ))
                            }
                        </div>
                    </React.Fragment>
                </React.Fragment>
            </Modal>
        );
    }
}

export default CreatePolarityModal;